import { render } from "./Testimonials2.vue?vue&type=template&id=6f4df67a&scoped=true"
import script from "./Testimonials2.vue?vue&type=script&lang=js"
export * from "./Testimonials2.vue?vue&type=script&lang=js"

import "./Testimonials2.vue?vue&type=style&index=0&id=6f4df67a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f4df67a"

export default script